import React, { useState } from 'react'

// Kendo components
import { Dialog } from '@progress/kendo-react-dialogs'
import { Scrollbars } from 'react-custom-scrollbars-2'
import { Form, FormElement } from '@progress/kendo-react-form'
import { BooleanCell, KendoGridShortDateCell } from './GridData'
import { Button } from '@progress/kendo-react-buttons'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import { FastQuoteInput, FastQuoteDropdownList } from '../../GlobalComponents/Inputs/Inputs'
import { formatDate } from '@telerik/kendo-intl'
import { orderBy, SortDescriptor } from '@progress/kendo-data-query'

import {
    fqAlert,
    NotificationManager,
    fqConfirm,
    fqConfirmAllowNo,
} from '../../GlobalComponents/NotificationManager/NotificationManager'

import styles from '.././PointOfSaleManager.module.scss'
import modalStyles from '../../GlobalComponents/GenericModals/GenericModals.module.scss'
import ModalTitleBar from './ModalTitleBar'
import { AWCButton, BUTTON_TYPES } from '../../GlobalComponents/Inputs/Inputs'
import {
    PointOfSaleReportDetail,
    PointOfSaleReportAdhocDetail,
    SubmitPointOfSaleReportAdhoc,
    SubmitPointOfSaleAdhocParams,
} from '../../features/invoice/invoiceAPI'
import { PointOfSaleAdhocModal } from './PointOfSaleAdhocModal'
import { fetchGetCurrentUser } from '../../features/meta/metaAPI'
import { TextArea } from '@progress/kendo-react-inputs'
import Switch from 'rc-switch'
import { String } from 'lodash'

export const PointOfSaleReportDetailModal: React.FC<{
    pointOfSaleReportDetail?: PointOfSaleReportDetail
    descriptionHandleChange: (event: any) => void
    activeHandleChange: (event: any) => void
    frequencyHandleChange: (event: any) => void
    emailRecipientsHandleChange: (event: any) => void
    emailCCRecipientsHandleChange: (event: any) => void
    emailSubjectHandleChange: (event: any) => void
    emailVerbiageHandleChange: (event: any) => void
    cancelDialog: () => void
    onSubmit: (event: any, pointofSaleReportDetail?: PointOfSaleReportDetail) => void
}> = (props) => {
    const initialSort: Array<SortDescriptor> = [{ field: 'RunDate', dir: 'desc' }]
    const [sort, setSort] = useState(initialSort)

    const [pointOfSaleAdhocItem, setPointOfSaleAdhocItem] = useState<
        PointOfSaleReportAdhocDetail | undefined
    >()
    const [showPointOfSaleAdhocForm, setShowPointOfSaleAdhocForm] = useState(false)

    // Get the row we want to edit
    const pointOfSaleAdhocClick = (event: any) => {
        if (!props.pointOfSaleReportDetail) return

        let pointOfSaleReportAdhocDetail: PointOfSaleReportAdhocDetail = {
            reportName: props.pointOfSaleReportDetail.reportName,
            vendorID: '0',
            fromDate: null,
            toDate: null,
            emailRecipients: '',
            emailCCRecipients: '',
            includeFieldnames: true,
            reportType: props.pointOfSaleReportDetail.reportType,
        }
        setPointOfSaleAdhocItem(pointOfSaleReportAdhocDetail)
        enterAdhoc(pointOfSaleReportAdhocDetail)
    }

    // Edit form
    const enterAdhoc = (pointOfSaleReportAdhocDetail: PointOfSaleReportAdhocDetail) => {
        setShowPointOfSaleAdhocForm(true)
        setPointOfSaleAdhocItem(pointOfSaleReportAdhocDetail)
    }

    const vendorIDHandleChange = (event: any) => {
        // pointOfSaleAdhocItem &&
        if (pointOfSaleAdhocItem && event.target.value === '0') {
            setPointOfSaleAdhocItem({
                ...pointOfSaleAdhocItem,
                vendorID: event.value.VendorID,
            })
        } else {
            pointOfSaleAdhocItem &&
                setPointOfSaleAdhocItem({
                    ...pointOfSaleAdhocItem,
                    vendorID: event.target.value,
                })
        }
    }

    const emailRecipientsHandleChange = (event: any) => {
        pointOfSaleAdhocItem &&
            setPointOfSaleAdhocItem({
                ...pointOfSaleAdhocItem,
                emailRecipients: event.target.value,
            })
    }

    const emailCCRecipientsHandleChange = (event: any) => {
        pointOfSaleAdhocItem &&
            setPointOfSaleAdhocItem({
                ...pointOfSaleAdhocItem,
                emailCCRecipients: event.target.value,
            })
    }

    const includeFieldnamesHandleChange = (value: boolean) => {
        pointOfSaleAdhocItem &&
            setPointOfSaleAdhocItem({
                ...pointOfSaleAdhocItem,
                includeFieldnames: value,
            })
    }

    const fromDateHandleChange = (newDate: any) => {
        pointOfSaleAdhocItem &&
            setPointOfSaleAdhocItem({
                ...pointOfSaleAdhocItem,
                fromDate: newDate.value,
            })
    }

    const toDateHandleChange = (newDate: any) => {
        pointOfSaleAdhocItem &&
            setPointOfSaleAdhocItem({
                ...pointOfSaleAdhocItem,
                toDate: newDate.value,
            })
    }

    // Run point of sale adhoc cancel
    const pointOfSaleAdhocCancel = () => {
        setShowPointOfSaleAdhocForm(false)
    }

    // point of sale adhoc submit
    const pointOfSaleAdhocSubmit = () => {
        if (!ValidateRequiredFields()) return

        CreatePointOfSaleReportBatchJob()
        setShowPointOfSaleAdhocForm(false)
    }

    const ValidateRequiredFields = (): boolean => {
        if (!pointOfSaleAdhocItem) return false

        let validationMessage: string = ''
        if (
            pointOfSaleAdhocItem.reportType === 'Standard' &&
            pointOfSaleAdhocItem.vendorID === '0'
        ) {
            validationMessage += 'Must choose a Vendor ID!\n'
        }
        if (pointOfSaleAdhocItem.fromDate === null) {
            validationMessage += 'Must enter a From Date!\n'
        }
        if (pointOfSaleAdhocItem.toDate === null) {
            validationMessage += 'Must enter a To Date!\n'
        }
        if (
            pointOfSaleAdhocItem.fromDate !== null &&
            pointOfSaleAdhocItem.toDate !== null &&
            pointOfSaleAdhocItem.fromDate > pointOfSaleAdhocItem.toDate
        ) {
            validationMessage += 'From Date must be less than To Date!\n'
        }
        if (pointOfSaleAdhocItem.emailRecipients === '') {
            validationMessage += 'Must enter Email To!'
        }

        if (validationMessage !== '') {
            fqAlert({
                type: 'error',
                title: 'Error',
                message: validationMessage,
            })
            return false
        }
        return true
    }

    async function CreatePointOfSaleReportBatchJob() {
        let currentUser = await fetchGetCurrentUser()
        let pointOfSaleAdhocParams: SubmitPointOfSaleAdhocParams = {
            Username: currentUser.Username,
            Email: currentUser.Email,
            paramsString:
                'REACTPOINTOFSALE|' +
                currentUser.CompanyCode +
                '|' +
                pointOfSaleAdhocItem!.reportType +
                '|' +
                pointOfSaleAdhocItem!.vendorID +
                '|' +
                formatDate(new Date(pointOfSaleAdhocItem!.fromDate!), 'MM/dd/yyyy') +
                '|' +
                formatDate(new Date(pointOfSaleAdhocItem!.toDate!), 'MM/dd/yyyy') +
                '|' +
                pointOfSaleAdhocItem!.includeFieldnames +
                '||' +
                pointOfSaleAdhocItem!.emailRecipients +
                '|' +
                pointOfSaleAdhocItem!.emailCCRecipients,
        }

        await SendPointOfSaleReportAdhoc(pointOfSaleAdhocParams)
    }

    // Submit point of sale report
    async function SendPointOfSaleReportAdhoc(
        submitPointOfSaleAdhocParams: SubmitPointOfSaleAdhocParams
    ) {
        try {
            if (await SubmitPointOfSaleReportAdhoc(submitPointOfSaleAdhocParams)) {
                fqAlert({
                    type: 'success',
                    message: 'Adhoc report successfully submitted to batch queue!',
                })
            } else {
                fqAlert({
                    type: 'error',
                    title: 'Error',
                    message: 'Error submitting adhoc point of sale report!',
                })
            }
        } catch (error) {
            console.error('Error submitting adhoc point of sale report!')
            fqAlert({
                type: 'error',
                title: 'Error',
                message: 'Error submitting adhoc point of sale report!',
            })
        }
    }

    return (
        <Dialog width="80%" height="90%" className="PointOfSaleManagerModal">
            <ModalTitleBar
                close={props.cancelDialog}
                title={props.pointOfSaleReportDetail!.reportName + ' Point of Sale Report'}
            />
            <Scrollbars
                className={'scroll-bar'}
                renderTrackHorizontal={() => <div />}
                renderTrackVertical={() => <div />}
            >
                <Form
                    onSubmitClick={(event: any) => {
                        props.onSubmit(event)
                    }}
                    initialValues={props.pointOfSaleReportDetail}
                    render={(formRenderProps) => {
                        return (
                            <FormElement className="PointOfSaleFormElement">
                                <div id="drop_zone">
                                    <div className={styles.wrap}>
                                        <div>
                                            <FastQuoteInput
                                                length="medium"
                                                title="Name"
                                                value={props.pointOfSaleReportDetail?.reportName}
                                                maxLength={50}
                                                style={{ marginTop: 23 }}
                                                disabled={true}
                                            />
                                        </div>
                                        {props.pointOfSaleReportDetail?.reportType !=
                                            'Standard' && (
                                            <div>
                                                <div className={styles.toggleTitle}>
                                                    Automation Active{' '}
                                                </div>
                                                <div style={{ maxWidth: 100, fontSize: 12 }}>
                                                    <Switch
                                                        className={styles.rcSwitch}
                                                        checkedChildren="Yes"
                                                        unCheckedChildren="No"
                                                        checked={
                                                            props.pointOfSaleReportDetail?.active
                                                        }
                                                        onChange={props.activeHandleChange}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {props.pointOfSaleReportDetail?.reportType !=
                                            'Standard' && (
                                            <div>
                                                <div className={styles.toggleTitle}>Frequency </div>
                                                <div style={{ maxWidth: 100, fontSize: 12 }}>
                                                    <Switch
                                                        className={styles.rcSwitch}
                                                        checkedChildren="Month"
                                                        unCheckedChildren="Quarter"
                                                        checked={
                                                            props.pointOfSaleReportDetail
                                                                ?.frequency === 'Monthly'
                                                        }
                                                        onChange={props.frequencyHandleChange}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <FastQuoteInput
                                            length="long"
                                            title="Description"
                                            value={props.pointOfSaleReportDetail?.description}
                                            onChange={props.descriptionHandleChange}
                                            useNativeOnChange={true}
                                            maxLength={250}
                                            style={{ marginTop: 25 }}
                                        />
                                        <FastQuoteInput
                                            length="long"
                                            title="Email To"
                                            value={props.pointOfSaleReportDetail?.emailRecipients}
                                            required={true}
                                            useNativeOnChange={true}
                                            onChange={props.emailRecipientsHandleChange}
                                            maxLength={440}
                                            style={{ marginTop: 25 }}
                                        />
                                        <FastQuoteInput
                                            length="long"
                                            title="Email CC"
                                            value={props.pointOfSaleReportDetail?.emailCCRecipients}
                                            useNativeOnChange={true}
                                            onChange={props.emailCCRecipientsHandleChange}
                                            maxLength={440}
                                            style={{ marginTop: 25 }}
                                        />
                                        <FastQuoteInput
                                            length="long"
                                            title="Email Subject"
                                            value={props.pointOfSaleReportDetail?.emailSubject}
                                            useNativeOnChange={true}
                                            onChange={props.emailSubjectHandleChange}
                                            maxLength={500}
                                            style={{ marginTop: 25 }}
                                        />

                                        <div className={styles.multiTextTitle}>
                                            Email Body
                                            <TextArea
                                                rows={20}
                                                maxLength={8000}
                                                style={{
                                                    minWidth: 800,
                                                    maxHeight: 200,
                                                    marginTop: -5,
                                                    borderWidth: 1,
                                                    borderColor: 'lightgray',
                                                    backgroundColor: 'white',
                                                    borderRadius: '4px',
                                                    fontSize: '1.1em',
                                                    padding: '6px 3px',
                                                }}
                                                onChange={props.emailVerbiageHandleChange}
                                                value={props.pointOfSaleReportDetail?.emailVerbiage}
                                            />
                                        </div>
                                    </div>

                                    <div className={styles.block} />

                                    <div className={styles.wrap}>
                                        <div>
                                            <div
                                                className={styles.bolded}
                                                style={{
                                                    textAlign: 'left',
                                                    paddingTop: 15,
                                                    paddingBottom: 10,
                                                }}
                                            >
                                                Report Logs
                                            </div>

                                            <Grid
                                                data={orderBy(
                                                    props.pointOfSaleReportDetail
                                                        ?.pointOfSaleReportLogs
                                                        ? props.pointOfSaleReportDetail
                                                              ?.pointOfSaleReportLogs
                                                        : [],
                                                    sort
                                                )}
                                                style={{ maxHeight: 300 }}
                                                sortable={true}
                                                sort={sort}
                                                scrollable="scrollable"
                                                onSortChange={(e: GridSortChangeEvent) => {
                                                    setSort(e.sort)
                                                }}
                                            >
                                                <GridColumn
                                                    title="Run Date"
                                                    field="runDate"
                                                    cell={KendoGridShortDateCell}
                                                />
                                                <GridColumn title="Run By" field="runBy" />
                                                <GridColumn
                                                    title="Status"
                                                    field="success"
                                                    cell={BooleanCell}
                                                />
                                                <GridColumn
                                                    title="From Date"
                                                    field="fromDate"
                                                    cell={KendoGridShortDateCell}
                                                />
                                                <GridColumn
                                                    title="To Date"
                                                    field="toDate"
                                                    cell={KendoGridShortDateCell}
                                                />
                                                <GridColumn
                                                    title="Failure Reason"
                                                    field="failureReason"
                                                />
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                            </FormElement>
                        )
                    }}
                />
            </Scrollbars>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '20px' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '110px 110px 110px',
                        marginTop: 10,
                    }}
                >
                    <AWCButton
                        type={'secondary'}
                        onClick={props.cancelDialog}
                        style={{
                            width: 94,
                        }}
                    >
                        Cancel
                    </AWCButton>
                    <AWCButton
                        type={'secondary'}
                        onClick={pointOfSaleAdhocClick}
                        style={{
                            width: 100,
                        }}
                    >
                        Run Ad Hoc
                    </AWCButton>
                    <AWCButton
                        type={BUTTON_TYPES.PRIMARY}
                        onClick={props.onSubmit}
                        style={{
                            width: 94,
                        }}
                    >
                        Submit
                    </AWCButton>
                </div>
            </div>
            {showPointOfSaleAdhocForm && (
                <PointOfSaleAdhocModal
                    pointOfSaleReportAdhocDetail={pointOfSaleAdhocItem}
                    cancelEdit={pointOfSaleAdhocCancel}
                    handleVendorIDChange={vendorIDHandleChange}
                    handleEmailRecipientsChange={emailRecipientsHandleChange}
                    handleEmailCCRecipientsChange={emailCCRecipientsHandleChange}
                    handleIncludeFieldnamesChange={includeFieldnamesHandleChange}
                    handleFromDateChange={fromDateHandleChange}
                    handleToDateChange={toDateHandleChange}
                    onSubmit={pointOfSaleAdhocSubmit}
                />
            )}
        </Dialog>
    )
}
